import React, {Dispatch, forwardRef, Key, SetStateAction} from 'react';

import {ModalOpenerComponent, IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TStateSetter} from 'shared/types/generics';
import {showMessage} from 'shared/utils';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {removeAisDocumentsInInterface, removeAisDocumentsInInterfaceByFilter} from 'store/slices/ais-slice/ais-slice-thunks';
import {selectIsThunkPending} from 'store/slices/loading-state-slice';

import {IDocumentsInterfaceParametersFilterForm} from '../../ais-documents-interface-types';

interface IDeleteConfirmationModalProps {
    isAllSelected: boolean;
    setIsAllSelected: Dispatch<SetStateAction<boolean>>;
    selectedRowKeys: Key[];
    documentsParametersFilter?: IDocumentsInterfaceParametersFilterForm;
    setSelectedRowKeys: TStateSetter<Key[]>;
    refetchTableData: () => void;
}

export const DeleteConfirmationModal = forwardRef<IModalOpenerComponentRef, IDeleteConfirmationModalProps>((
    {
        isAllSelected,
        selectedRowKeys,
        documentsParametersFilter,
        refetchTableData,
        setSelectedRowKeys,
        setIsAllSelected,
    }: IDeleteConfirmationModalProps,
    ref,
) => {
    const dispatch = useAppDispatch();

    const isDeleting = useAppSelector(s => selectIsThunkPending(s, removeAisDocumentsInInterface.typePrefix));

    const handleDelete = (setIsModalOpen: TStateSetter<boolean>) => {
        const res = isAllSelected
            ? dispatch(removeAisDocumentsInInterfaceByFilter({...documentsParametersFilter}))
            : dispatch(removeAisDocumentsInInterface({ids: selectedRowKeys} as {ids: number[]}));

        res.unwrap().then(() => {
            showMessage({message: 'Записи успешно удалены'});
            setSelectedRowKeys([]);
            setIsModalOpen(false);
            setIsAllSelected(false);
            refetchTableData();
        }, error => {
            const {data: responseMessage, status} = error?.response;
            const isBadRequest = status === 400;
            const message = isBadRequest && responseMessage
                ? responseMessage : 'Во время удаления записей произошла ошибка';
            showMessage({message, isError: true});
        });
    };

    return (
        <ModalOpenerComponent
            ref={ref}
            modalProps={{
                forceRender: false,
                destroyOnClose: true,
                title: 'Подтверждение',
                centered: true,
            }}
            controlLabels={{
                save: 'Удалить',
            }}
            loadingControls={{
                save: isDeleting,
            }}
            disabledControls={{
                save: isDeleting,
            }}
            handleSave={setIsModalOpen => {
                handleDelete(setIsModalOpen);
            }}
        >
            Вы действительно хотите удалить выбранные записи?
        </ModalOpenerComponent>
    );
});
